import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import Terms from '@/views/terms/List.vue';

export const termsListRoute: RouteConfig = {
  path: 'terms',
  name: 'terms',
  component: Terms,
  beforeEnter: (to, from, next) => {
    store.dispatch('terms/list', baseFilters(to)).then(() => {
      store.commit('breadcrumbs/set', [{ text: 'Regulaminy', disabled: true }]);
      next();
    });
  },
  meta: { toolbarTitle: 'Lista regulaminów' }
};
